import React, { useState } from 'react';

// the 64px thumbnail (`s=1`): a tile is 28px, and the full embedded art can
// run to megabytes — the route serves it from the disk cache when the library
// knows the file.
// `clear=1`: a track with no embedded art answers with a transparent tile
// instead of the ♫ placeholder, so the set's own artwork shows through. The
// placeholder is served with a 200, so onError never fires on it — asking for
// the clear one is the only way to tell "no art" from "art".
const artUrl = (p) => `http://localhost:3069/album-art?path=${encodeURIComponent(p)}&s=1&clear=1`;

// A track with no embedded art renders NOTHING, so the set's own default
// artwork (the .amx-mosaic background: the crossing-curves mark on a tint)
// shows through. A set without art should not look like a track without art —
// the music-note tile was the track placeholder, which is what made a whole
// set look like one untagged file.
const Tile = ({ path }) => {
    const [failed, setFailed] = useState(false);
    if (!path || failed) return <span className="amx-mosaic-blank" />;
    return (
        <img
            src={artUrl(path)}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
        />
    );
};

/** A set's cover: the artwork of its first four tracks (one tile when fewer). */
const AutomixMosaic = ({ paths = [], size = 56, className = '' }) => {
    const list = paths || [];
    const tiles = list.length >= 4 ? list.slice(0, 4) : list.slice(0, 1);
    return (
        <span
            className={`amx-mosaic${tiles.length === 4 ? ' is-quad' : ''}${className ? ` ${className}` : ''}`}
            style={{ width: size, height: size }}
            aria-hidden="true"
        >
            {(tiles.length ? tiles : [null]).map((p, i) => <Tile key={`${p}-${i}`} path={p} />)}
        </span>
    );
};

export default AutomixMosaic;
